<template>
  <b-card-code title="Colors">
    <b-card-text class="mb-0">
      <span>Use the </span>
      <code>variant</code>
      <span> prop to specify one of theme variant colors.</span>
      <span> Use the </span>
      <code>variant="light-{color-name}"</code>
      <span> to change background color of your avatar.</span>
    </b-card-text>

    <div class="demo-inline-spacing">
      <b-avatar
        variant="primary"
        text="EP"
      />
      <b-avatar
        variant="secondary"
        text="EP"
      />
      <b-avatar
        variant="success"
        text="EP"
      />
      <b-avatar
        text="EP"
        variant="light-danger"
      />
      <b-avatar
        text="EP"
        variant="light-warning"
      />
      <b-avatar
        text="EP"
        variant="light-info"
      />
    </div>

    <template #code>
      {{ codeColor }}
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { BAvatar, BCardText } from 'bootstrap-vue'
import { codeColor } from './code'

export default {
  components: {
    BCardCode,
    BAvatar,
    BCardText,
  },
  data() {
    return {
      codeColor,
    }
  },
}
</script>
